export const safeAuthDestination = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/events';
  const [path] = value.split('?');
  if (!['/events', '/vote'].includes(path) && !/^\/events\/[a-zA-Z0-9_-]{1,100}$/.test(path)) return '/events';
  if (value.includes('#')) return '/events';
  const params = new URLSearchParams(value.split('?')[1] || '');
  const clean = new URLSearchParams();
  ['category', 'search', 'status'].forEach(key => {
    if (params.get(key)) clean.set(key, params.get(key).slice(0, 200));
  });
  if (/^\/events\/[a-zA-Z0-9_-]{1,100}$/.test(path) && ['A', 'B'].includes(params.get('draft'))) clean.set('draft', params.get('draft'));
  return path + (clean.toString() ? `?${clean}` : '');
};

export const signInPath = (destination) => `/login?next=${encodeURIComponent(safeAuthDestination(destination))}`;

export const authErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg || 'Please check your details.').join(' ');
  return detail?.message || fallback;
};

const PENDING_LINK = 'pharmaconsensus-pending-email-link';

export const readPendingEmailLink = () => {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const token = hash.get('token');
  const next = safeAuthDestination(new URLSearchParams(window.location.search).get('next'));
  if (token) {
    const pending = { token, destination: next };
    try { sessionStorage.setItem(PENDING_LINK, JSON.stringify(pending)); } catch { /* Continue in memory when browser storage is unavailable. */ }
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    return pending;
  }
  try {
    return JSON.parse(sessionStorage.getItem(PENDING_LINK)) || { token: '', destination: next };
  } catch {
    return { token: '', destination: next };
  }
};

export const clearPendingEmailLink = () => { try { sessionStorage.removeItem(PENDING_LINK); } catch {} };